import React, { useEffect } from 'react';
import { string, bool, func } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources/react/dataModel/useDataModel';
import {
  params,
  string as stringType,
  shape as shapeType,
} from '@thd-nucleus/data-sources';
import { CtaSection } from '../common/CtaSection';
import { buildSamLink } from '../../utils/home-services-cta-utils';

const ScheduleAMeasureCta = ({
  itemId, onClick, hideBadge, hideContactInfo
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('schedule-a-measure.ready'); }, []);

  const opts = {
    variables: {
      itemId
    },
    ssr: true,
  };

  const { data } = useDataModel('product', opts);

  if (!itemId || !data) {
    return null;
  }

  const {
    modelNumber
  } = data?.product?.identifiers;

  return (
    <CtaSection
      buttonText="Schedule a Measure"
      contactNumber="1-866-948-9023"
      buttonLink={buildSamLink(modelNumber)}
      hideBadge={hideBadge}
      hideContactInfo={hideContactInfo}
      openContentInOverlay={false}
      onClick={onClick}
    />
  );
};

ScheduleAMeasureCta.displayName = 'ScheduleAMeasureCta';

ScheduleAMeasureCta.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shapeType({
      modelNumber: stringType()
    })
  }),
};

ScheduleAMeasureCta.propTypes = {
  itemId: string.isRequired,
  onClick: func,
  hideBadge: bool,
  hideContactInfo: bool,
};

ScheduleAMeasureCta.defaultProps = {
  hideBadge: false,
  hideContactInfo: false,
  onClick: () => {},
};

export { ScheduleAMeasureCta };